const en = {
  tab_text: 'Send feedback',
  option_title_text: 'Choose an option',
  option_pin_text: 'I have feedback regarding a specific part of this page.',
  option_site_text: 'I have feedback regarding this page or site as a whole.',
  option_site_recording:
    '🎥 I’d like to record a video to demonstrate my feedback.',
  pin_instruction_text:
    'Hover over page elements to highlight them, then click to create an annotation.',
  feedback_title: 'New Feedback',
  feedback_entry_placeholder: 'Write a comment or describe a problem',
  feedback_email_placeholder: 'Your email address',
  feedback_submit_text: 'Send Feedback',
  confirm_success_text: 'Your feedback was sent.',
  confirm_loading_text: 'Sending feedback.',
  confirm_close_text: 'close',
  confirm_error_text: 'Sending feedback was unsuccessful.',
  confirm_retry_text: 'Try again',
  confirm_extension_text:
    'Did you know you can send a screenshot with your bug reports?',
  confirm_extension_link_text: 'Find out how.',
  feedback_consent: 'I consent to data collection as per the',
  privacy_policy: 'privacy policy',
  touch_instruction_text: 'Touch anywhere to create an annotation on that area',
  powered_by: 'powered by',
  dragger_hover_text: 'MOVE ME',
  loading_message: 'Creating task...',
  uploading_message: 'Uploading video. This may take a moment.',
  close: 'Close',
  success_message: 'Your feedback was sent.',
  try_again: 'Try again'
};

const de = {
  tab_text: 'Feedback zur Seite',
  option_title_text: 'Wähle eine Option',
  option_pin_text:
    'Ich habe Feedback zu einem bestimmten Element auf dieser Seite.',
  option_site_text:
    'Ich habe Feedback zu dieser Seite oder der Website im Allgemeinen',
  option_site_recording:
    '🎥 I’d like to record a video to demonstrate my feedback.',
  pin_instruction_text:
    'Hover over page elements to highlight them, then click to create an annotation.',
  feedback_title: 'Feedback zur Seite',
  feedback_entry_placeholder:
    'Beschreibe das Problem oder hinterlasse hier dein Kommentar',
  feedback_email_placeholder: 'Deine Email-Adresse',
  feedback_submit_text: 'Absenden',
  confirm_success_text: 'Dein Feedback wurde erfasst.',
  confirm_loading_text: 'Feedback wird gesendet',
  confirm_close_text: 'close',
  confirm_error_text: 'Sending feedback was unsuccessful.',
  confirm_retry_text: 'Try again',
  confirm_extension_text:
    'Did you know you can send a screenshot with your bug reports?',
  confirm_extension_link_text: 'Find out how.',
  feedback_consent: 'Ich stimme der Datenerhebung gemäß der',
  privacy_policy: 'Datenschutzbestimmungen',
  touch_instruction_text: 'Touch anywhere to create an annotation on that area',
  powered_by: 'powered by ',
  dragger_hover_text: 'MOVE ME',
  close: 'Schließen',
  success_message: 'Ihr Feedback wurde versendet.'
};

const fr = {
  tab_text: 'Envoyer mes commentaires',
  option_title_text: 'Choisir une option',
  option_pin_text:
    "J'ai un commentaire concernant une partie spécifique de cette page.",
  option_site_text:
    "J'ai un commentaire concernant cette page ou le site en entier.",
  option_site_recording:
    '🎥 I’d like to record a video to demonstrate my feedback.',
  pin_instruction_text:
    'Survolez les éléments de la page pour les mettre en surbrillance et cliquez pour créer une note.',
  feedback_title: 'Nouveau commentaire',
  feedback_entry_placeholder: 'Écrire un commentaire ou décrire un problème',
  feedback_email_placeholder: 'Votre adresse courriel',
  feedback_submit_text: 'Envoyer mes commentaires',
  confirm_success_text: 'Vos commentaires ont été envoyés.',
  confirm_loading_text: 'Envoi de commentaire',
  confirm_close_text: 'close',
  confirm_error_text: "L'envoi de commentaire a échoué.",
  confirm_retry_text: 'Réessayer',
  confirm_extension_text:
    "Saviez-vous que vous pouviez joindre une capture d'écran à vos rapports d'erreur?",
  confirm_extension_link_text: 'Découvrez comment faire.',
  feedback_consent: 'Je consens à la collecte de données conformément à la',
  privacy_policy: 'politique de confidentialité',
  touch_instruction_text:
    "Touchez n'importe où pour créer une note dans cette zone.",
  powered_by: 'Propulsé par ',
  dragger_hover_text: 'MOVE ME',
  close: 'Fermer',
  success_message: 'Votre commentaire a été envoyé'
};

const he = {
  tab_text: 'שלח משוב',
  option_title_text: 'בחר אפשרות',
  option_pin_text: '.יש לי משוב לגבי חלק מסוים בדף זה',
  option_site_text: '.יש לי משוב לגבי דף זה או כל האתר',
  option_site_recording:
    '🎥 I’d like to record a video to demonstrate my feedback.',
  pin_instruction_text:
    'העבר את העכבר מעל רכיבי עמוד כדי להדגיש .אותם, ולאחר מכן לחץ כדי ליצור הערה',
  feedback_title: 'משוב חדש',
  feedback_entry_placeholder: 'כתוב הערה או תאר בעיה',
  feedback_email_placeholder: 'כתובת הדוא"ל שלך',
  feedback_submit_text: 'שלח משוב',
  confirm_success_text: '.המשוב שלך נשלח',
  confirm_loading_text: '.שולח משוב',
  confirm_close_text: 'סגור',
  confirm_error_text: '.שליחת משוב לא הצליחה',
  confirm_retry_text: 'נסה שנית',
  confirm_extension_text:
    'האם ידעתם שאפשר לשלוח צילום מסך עם דוח תקלות תוכנה (באגס)?',
  confirm_extension_link_text: '.גלו איך',
  privacy_policy: 'privacy policy',
  feedback_consent:
    'אני מסכים לאיסוף המידע שאני מספק וצילומי מסך שנוצרו כחלק מתהליך המשוב, לשימוש בהתאם למדיניות הפרטיות של BugHerd',
  touch_instruction_text: 'לחצו בכל מקום על המסך כדי ליצור הערה על אותו אזור',
  powered_by: 'מופעל על ידי',
  dragger_hover_text: 'MOVE ME',
  loading_message: 'Creating task...',
  uploading_message: 'Uploading video. This may take a moment.',
  close: 'Close',
  success_message: 'Your feedback was sent.',
  try_again: 'Try again'
};

const nl = {
  tab_text: 'Stuur feedback',
  option_title_text: 'Kies een optie',
  option_pin_text: 'Ik heb feedback over een specifiek deel van deze pagina.',
  option_site_text:
    'Ik heb feedback over deze pagina of de website in het algemeen.',
  option_site_recording:
    '🎥 I’d like to record a video to demonstrate my feedback.',
  pin_instruction_text:
    'Beweeg over pagina-elementen om ze te markeren en klik vervolgens om een annotatie te maken.',
  feedback_title: 'Nieuwe feedback',
  feedback_entry_placeholder: 'schrijf een opmerking of beschrijf een probleem',
  feedback_email_placeholder: 'je e-mailadres',
  feedback_submit_text: 'verstuur feedback',
  confirm_success_text: 'Je feedback is verzonden.',
  confirm_loading_text: 'Bezig met verzenden van feedback.',
  confirm_close_text: 'sluiten',
  confirm_error_text: 'Het verzenden van feedback is mislukt.',
  confirm_retry_text: 'Probeer opnieuw',
  confirm_extension_text:
    'Wist je dat je een screenshot kunt meesturen met je bugrapporten?',
  confirm_extension_link_text: 'Ontdek hoe.',
  privacy_policy: 'privacy policy',
  feedback_consent:
    'Ik geef toestemming voor het verzamelen van de informatie die ik verstrek en de screenshots die worden gemaakt als onderdeel van het feedbackproces, om te worden gebruikt in overeenstemming met het privacybeleid van BugHerd.',
  touch_instruction_text:
    'Tik ergens om een annotatie te maken op het selecterde ',
  powered_by: 'powered by',
  dragger_hover_text: 'MOVE ME',
  loading_message: 'Creating task...',
  uploading_message: 'Uploading video. This may take a moment.',
  close: 'Close',
  success_message: 'Your feedback was sent.',
  try_again: 'Try again'
};

const languages = { en, fr, de, he, nl };
export type SupportedLocales = keyof typeof languages;
type Translations = typeof en & typeof fr & typeof de & typeof he & typeof nl;

export const translations = (locale: SupportedLocales): Translations => {
  const customTranslations = window.BugHerdConfig?.feedback;
  if (customTranslations) {
    return {
      ...languages[locale],
      ...customTranslations
    };
  }
  return languages[locale];
};
